export default __webpack_public_path__ + "static/autonl-7f239d5e0b748d4ba0b8e424359e0b22.png";